/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CommissionRateServiceVo
 */
export interface CommissionRateServiceVo {
    /**
     * 附加服务id
     * @type {number}
     * @memberof CommissionRateServiceVo
     */
    additionalServiceId?: number;
    /**
     * 附加服务名称
     * @type {string}
     * @memberof CommissionRateServiceVo
     */
    name?: string;
    /**
     * 附加服务名称-中文
     * @type {string}
     * @memberof CommissionRateServiceVo
     */
    nameCn?: string;
    /**
     * 附加服务分组名称
     * @type {string}
     * @memberof CommissionRateServiceVo
     */
    groupName?: string;
    /**
     * 附加服务分组名称-中文
     * @type {string}
     * @memberof CommissionRateServiceVo
     */
    groupNameCn?: string;
    /**
     * 附加服务分组ID
     * @type {number}
     * @memberof CommissionRateServiceVo
     */
    groupId?: number;
    /**
     * 附加服务价格
     * @type {number}
     * @memberof CommissionRateServiceVo
     */
    price?: number;
    /**
     * 货币代码
     * @type {string}
     * @memberof CommissionRateServiceVo
     */
    currencyCode?: string;
    /**
     * 分成比例%（查看接口返回，初始化接口为空）
     * @type {number}
     * @memberof CommissionRateServiceVo
     */
    rate?: number;
}

/**
 * Check if a given object implements the CommissionRateServiceVo interface.
 */
export function instanceOfCommissionRateServiceVo(value: object): value is CommissionRateServiceVo {
    return true;
}

export function CommissionRateServiceVoFromJSON(json: any): CommissionRateServiceVo {
    return CommissionRateServiceVoFromJSONTyped(json, false);
}

export function CommissionRateServiceVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommissionRateServiceVo {
    if (json == null) {
        return json;
    }
    return {
        
        'additionalServiceId': json['additionalServiceId'] == null ? undefined : json['additionalServiceId'],
        'name': json['name'] == null ? undefined : json['name'],
        'nameCn': json['nameCn'] == null ? undefined : json['nameCn'],
        'groupName': json['groupName'] == null ? undefined : json['groupName'],
        'groupNameCn': json['groupNameCn'] == null ? undefined : json['groupNameCn'],
        'groupId': json['groupId'] == null ? undefined : json['groupId'],
        'price': json['price'] == null ? undefined : json['price'],
        'currencyCode': json['currencyCode'] == null ? undefined : json['currencyCode'],
        'rate': json['rate'] == null ? undefined : json['rate'],
    };
}

export function CommissionRateServiceVoToJSON(json: any): CommissionRateServiceVo {
    return CommissionRateServiceVoToJSONTyped(json, false);
}

export function CommissionRateServiceVoToJSONTyped(value?: CommissionRateServiceVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'additionalServiceId': value['additionalServiceId'],
        'name': value['name'],
        'nameCn': value['nameCn'],
        'groupName': value['groupName'],
        'groupNameCn': value['groupNameCn'],
        'groupId': value['groupId'],
        'price': value['price'],
        'currencyCode': value['currencyCode'],
        'rate': value['rate'],
    };
}

